// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
  position: relative;
  display: flex;
}
.switch__checkbox {
  height: 3rem;
  width: 3rem;
  position: absolute;
  left: 0;
  top: -0.75rem;
  display: inline-block;
  border: 0;
  opacity: 0;
  padding: 0;
  z-index: 1;
  cursor: pointer;
}
[dir=rtl] .switch__checkbox {
  right: 0;
  left: auto;
}
.switch__label {
  font-size: 0.875rem;
  line-height: 1.571;
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
  cursor: pointer;
  position: relative;
  display: inline;
  padding-inline-start: 1rem;
  transition: color 200ms ease-in-out;
}
.switch__toggle {
  position: relative;
  display: flex;
  flex-shrink: 0;
  cursor: pointer;
  height: 1.5rem;
  width: 3rem;
}
.switch__toggle::before {
  content: "";
  display: block;
  width: 100%;
  background: border-box rgb(var(--colour-neutral-5, 146, 146, 146));
  border: 1px solid transparent;
  transition: background 200ms cubic-bezier(0, 0, 1, 1);
  height: 1.5rem;
  border-radius: 20px;
}
.switch__symbol::before {
  transform: rotate(45deg);
  content: "";
  box-sizing: content-box;
  display: block;
  opacity: 0;
  transition: all 100ms cubic-bezier(0, 0, 1, 1);
  border: 2px solid rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163));
  border-left: 0;
  border-top: 0;
  height: 0.5625rem;
  width: 0.25rem;
  margin-top: -0.25rem;
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}
.switch__button {
  position: absolute;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.125rem;
  background: border-box rgb(var(--colour-static-white, 255, 255, 255));
  border-radius: 20px;
  border: 2px solid transparent;
  transition: transform 200ms cubic-bezier(0.4, 0, 0.4, 1);
  width: 1.25rem;
  height: 1.25rem;
}
[dir=rtl] .switch__button {
  right: 0;
  left: auto;
}
.switch__checkbox:checked + .switch__toggle::before {
  background: rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163));
}
.switch__checkbox:checked + .switch__toggle .switch__symbol::before {
  opacity: 1;
}
.switch__checkbox:checked + .switch__toggle .switch__button {
  transform: translateX(120%);
}
[dir=rtl] .switch__checkbox:checked + .switch__toggle .switch__button {
  transform: translateX(-120%);
}
.switch--subtle .switch__button {
  background: rgb(var(--colour-neutral-1, 255, 255, 255));
}
.switch--subtle .switch__checkbox:checked + .switch__toggle::before {
  background: rgb(var(--colour-interactive-primary-bg-default, 17, 17, 17));
}
.switch--subtle .switch__checkbox:checked + .switch__toggle .switch__symbol::before {
  border-color: rgb(var(--colour-neutral-7, 17, 17, 17));
}
.switch .switch__checkbox:hover:checked + .switch__toggle::before {
  background: rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147));
}
.switch .switch__checkbox:hover:checked + .switch__toggle .switch__symbol::before {
  border-color: rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147));
}
.switch--subtle .switch__checkbox:hover:checked + .switch__toggle::before {
  background: rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51));
}
.switch--subtle .switch__checkbox:hover:checked + .switch__toggle .switch__symbol::before {
  border-color: rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51));
}
.switch .switch__checkbox:active:checked + .switch__toggle::before {
  background: rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114));
}
.switch .switch__checkbox:active:checked + .switch__toggle .switch__symbol::before {
  border-color: rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114));
}
.switch--subtle .switch__checkbox:active:checked + .switch__toggle::before {
  background: rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0));
}
.switch--subtle .switch__checkbox:active:checked + .switch__toggle .switch__symbol::before {
  border-color: rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0));
}
.switch .switch__checkbox:disabled {
  cursor: default;
}
.switch .switch__checkbox:disabled ~ .switch__label {
  pointer-events: none;
  color: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}
.switch .switch__checkbox:disabled:hover + .switch__toggle::before,
.switch .switch__checkbox:disabled + .switch__toggle::before {
  background: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}
.switch .switch__checkbox:disabled:hover + .switch__toggle .switch__symbol::before,
.switch .switch__checkbox:disabled + .switch__toggle .switch__symbol::before {
  border-color: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}
@media (forced-colors: active) {
  .switch .switch__checkbox:disabled ~ .switch__label {
    color: GrayText;
  }
  .switch .switch__checkbox:disabled + .switch__toggle::before,
  .switch .switch__checkbox:disabled + .switch__toggle > .switch__button,
  .switch .switch__checkbox:disabled + .switch__toggle .switch__symbol::before,
  .switch .switch__checkbox:disabled:hover + .switch__toggle .switch__symbol::before {
    border-color: GrayText;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/switch/dist/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,UAAU;EACV,UAAU;EACV,eAAe;AACjB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,kEAAkE;EAClE,6BAA6B;EAC7B,qDAAqD;EACrD,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,8CAA8C;EAC9C,kFAAkF;EAClF,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qEAAqE;EACrE,mBAAmB;EACnB,6BAA6B;EAC7B,wDAAwD;EACxD,cAAc;EACd,eAAe;AACjB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,sDAAsD;AACxD;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,uEAAuE;AACzE;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,8EAA8E;AAChF;AACA;EACE,sEAAsE;AACxE;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,+DAA+D;AACjE;AACA;;EAEE,oEAAoE;AACtE;AACA;;EAEE,sEAAsE;AACxE;AACA;EACE;IACE,eAAe;EACjB;EACA;;;;IAIE,sBAAsB;EACxB;AACF","sourcesContent":[".switch {\n  position: relative;\n  display: flex;\n}\n.switch__checkbox {\n  height: 3rem;\n  width: 3rem;\n  position: absolute;\n  left: 0;\n  top: -0.75rem;\n  display: inline-block;\n  border: 0;\n  opacity: 0;\n  padding: 0;\n  z-index: 1;\n  cursor: pointer;\n}\n[dir=rtl] .switch__checkbox {\n  right: 0;\n  left: auto;\n}\n.switch__label {\n  font-size: 0.875rem;\n  line-height: 1.571;\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n  cursor: pointer;\n  position: relative;\n  display: inline;\n  padding-inline-start: 1rem;\n  transition: color 200ms ease-in-out;\n}\n.switch__toggle {\n  position: relative;\n  display: flex;\n  flex-shrink: 0;\n  cursor: pointer;\n  height: 1.5rem;\n  width: 3rem;\n}\n.switch__toggle::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  background: border-box rgb(var(--colour-neutral-5, 146, 146, 146));\n  border: 1px solid transparent;\n  transition: background 200ms cubic-bezier(0, 0, 1, 1);\n  height: 1.5rem;\n  border-radius: 20px;\n}\n.switch__symbol::before {\n  transform: rotate(45deg);\n  content: \"\";\n  box-sizing: content-box;\n  display: block;\n  opacity: 0;\n  transition: all 100ms cubic-bezier(0, 0, 1, 1);\n  border: 2px solid rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163));\n  border-left: 0;\n  border-top: 0;\n  height: 0.5625rem;\n  width: 0.25rem;\n  margin-top: -0.25rem;\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n.switch__button {\n  position: absolute;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0.125rem;\n  background: border-box rgb(var(--colour-static-white, 255, 255, 255));\n  border-radius: 20px;\n  border: 2px solid transparent;\n  transition: transform 200ms cubic-bezier(0.4, 0, 0.4, 1);\n  width: 1.25rem;\n  height: 1.25rem;\n}\n[dir=rtl] .switch__button {\n  right: 0;\n  left: auto;\n}\n.switch__checkbox:checked + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163));\n}\n.switch__checkbox:checked + .switch__toggle .switch__symbol::before {\n  opacity: 1;\n}\n.switch__checkbox:checked + .switch__toggle .switch__button {\n  transform: translateX(120%);\n}\n[dir=rtl] .switch__checkbox:checked + .switch__toggle .switch__button {\n  transform: translateX(-120%);\n}\n.switch--subtle .switch__button {\n  background: rgb(var(--colour-neutral-1, 255, 255, 255));\n}\n.switch--subtle .switch__checkbox:checked + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-primary-bg-default, 17, 17, 17));\n}\n.switch--subtle .switch__checkbox:checked + .switch__toggle .switch__symbol::before {\n  border-color: rgb(var(--colour-neutral-7, 17, 17, 17));\n}\n.switch .switch__checkbox:hover:checked + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147));\n}\n.switch .switch__checkbox:hover:checked + .switch__toggle .switch__symbol::before {\n  border-color: rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147));\n}\n.switch--subtle .switch__checkbox:hover:checked + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51));\n}\n.switch--subtle .switch__checkbox:hover:checked + .switch__toggle .switch__symbol::before {\n  border-color: rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51));\n}\n.switch .switch__checkbox:active:checked + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114));\n}\n.switch .switch__checkbox:active:checked + .switch__toggle .switch__symbol::before {\n  border-color: rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114));\n}\n.switch--subtle .switch__checkbox:active:checked + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0));\n}\n.switch--subtle .switch__checkbox:active:checked + .switch__toggle .switch__symbol::before {\n  border-color: rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0));\n}\n.switch .switch__checkbox:disabled {\n  cursor: default;\n}\n.switch .switch__checkbox:disabled ~ .switch__label {\n  pointer-events: none;\n  color: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));\n}\n.switch .switch__checkbox:disabled:hover + .switch__toggle::before,\n.switch .switch__checkbox:disabled + .switch__toggle::before {\n  background: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));\n}\n.switch .switch__checkbox:disabled:hover + .switch__toggle .switch__symbol::before,\n.switch .switch__checkbox:disabled + .switch__toggle .switch__symbol::before {\n  border-color: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));\n}\n@media (forced-colors: active) {\n  .switch .switch__checkbox:disabled ~ .switch__label {\n    color: GrayText;\n  }\n  .switch .switch__checkbox:disabled + .switch__toggle::before,\n  .switch .switch__checkbox:disabled + .switch__toggle > .switch__button,\n  .switch .switch__checkbox:disabled + .switch__toggle .switch__symbol::before,\n  .switch .switch__checkbox:disabled:hover + .switch__toggle .switch__symbol::before {\n    border-color: GrayText;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
